exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".question{text-align:left;color:#555555;margin-bottom:5rem}.question .question-title{font-family:inherit;font-weight:600;font-size:2.25em;color:#1A242E;min-height:11.25rem}.question .question-title .question-title-image{vertical-align:middle;max-width:4rem;height:1em}.question .italic{font-style:italic}.question .question-subtitle{font-family:inherit;font-size:1.75em;line-height:1.2em}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss","plugins":[null,null]}!./src/pages/Questionnaires/Question/style.scss
// module id = 2102
// module chunks = 0